const doc = [({"da":({"js":({"admin":({"steps":({"element":({"the_element_was_duplicated":"Elementet blev duplikeret"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;